import axios from 'axios';

const BASE = '/produccion/ordenes';

export default {
  index() {
    return axios.get(BASE);
  },
  show(id) {
    return axios.get(`${BASE}/${id}`);
  },
  create(data) {
    return axios.post(BASE, data);
  },
  destroy(id) {
    return axios.delete(`${BASE}/${id}`);
  },
  iniciar(id, maquina) {
    return axios.post(`${BASE}/${id}/iniciar`, maquina ? { maquina } : {});
  },
  dividir(id, partes) {
    return axios.post(`${BASE}/${id}/dividir`, { partes });
  },
  confirmar(id) {
    return axios.post(`${BASE}/${id}/confirmar`);
  },
  cancelar(id) {
    return axios.post(`${BASE}/${id}/cancelar`);
  },
  plan(ordenPreparacionId) {
    return axios.get(`/produccion/plan-produccion/${ordenPreparacionId}`);
  },
  planConsolidado() {
    return axios.get('/produccion/plan-consolidado');
  },
  generarOrdenesPedido(ordenPreparacionId) {
    return axios.post(`/produccion/generar-ordenes-pedido/${ordenPreparacionId}`);
  },
  generarOrdenes() {
    return axios.post('/produccion/generar-ordenes');
  },
  generarOrdenesPlan(lineas) {
    return axios.post('/produccion/generar-ordenes-plan', { lineas });
  },
};
